module.exports = __webpack_public_path__ + "static/assets/80a61a0e37fdbad0ea442c7fc7546045.svg";